<template>
  <div class="documents-formation-entreprise">
    <va-modal
      :title=" 'Documents RNE de l\'entreprise ' + entrepriseNom "
      class="modal"
      v-model="showDocuments"
      cancelText="Annuler"
      okText="Fermer"
      max-width="100%"
      v-on:ok="closeModal"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
    >
      <div class="customsize">
        <div class="row row-inside">
          <div class="flex md6 setheight">
            <h3 class="mb-3">Ajout document RNE (PDF uniquement)</h3>
            <div class="row row-inside mb-4">
              <div class="flex md2">
                <va-file-upload
                  label="Document RNE (PDF uniquement)"
                  type="single"
                  file-types=".pdf"
                  v-model="uploadFormData.file"
                  color="info"
                > Document RNE (PDF uniquement) </va-file-upload>
              </div>
              <div class="flex md2 mx-2">
                <va-input
                  v-model="uploadFormData.date_document"
                  label="Date du document"
                  type="date"
                  required
                />
              </div>
              <div class="flex md3">
                <va-button
                  color="info"
                  icon="fa fa-plus"
                  style="margin-bottom: 16px;"
                  @click="uploadDocument"
                  :disabled="!uploadFormData.file || !uploadFormData.date_document"
                >
                  Téléverser le document
                </va-button>
              </div>
            </div>
            <va-separator />
            <h3 class="mb-2">Documents RNE</h3>
            <va-data-table
              class="va-table--hoverable va-table--stripped"
              :fields="fieldsDocuments"
              :data="documentsList"
              no-data-label="Aucun document trouvé"
              :per-page="parseInt(perPage)"
            >
              <template
                slot="validity"
                slot-scope="props"
              >
                <va-button
                  round
                  size="small"
                  :color="props.rowData.validity ? 'success' : 'danger'"
                  :title="props.rowData.validity ? 'Valide' : 'Invalide'"
                  icon="fa fa-check"
                  v-if="props.rowData.validity"
                />
                <va-button
                  round
                  size="small"
                  color="danger"
                  title="Invalide"
                  icon="fa fa-times"
                  v-else
                />
              </template>
              <template
                slot="actions"
                slot-scope="props"
              >
                <div class="document-content">
                  <va-button
                    class="document-button"
                    icon="fa fa-download"
                    color="info"
                    @click="downloadDocument(props.rowData.idformation_rne)"
                  >
                    Télécharger
                  </va-button>
                  <va-button
                    class="document-button"
                    icon="fa fa-eye"
                    color="primary"
                    @click="viewDocument(props.rowData.idformation_rne)"
                    style="margin-left: 8px;"
                  >
                    Visualiser
                  </va-button>
                  <va-button
                    class="document-button"
                    icon="fa fa-trash"
                    color="danger"
                    @click="deleteDocument(props.rowData.idformation_rne)"
                    style="margin-left: 8px;"
                  >
                    Supprimer
                  </va-button>
                </div>
              </template>
            </va-data-table>

          </div>
          <div class="flex md6">
            <h3 class="mb-3">Aperçu du document</h3>

            <iframe
              id="iframeDocument"
              ref="iframeDocument"
              v-if="pdfurl !== ''"
              class="fullsize"
              :src="pdfurl"
            />
            <div
              v-else
              class="fullsize flex flex-center"
              style="background-color: #f5f5f5; justify-content: center; align-items: center;"
            >
              <p style="text-align: center; color: #888;">Aucun document sélectionné</p>
            </div>

          </div>
        </div>
      </div>
    </va-modal>

    <va-modal
      v-model="showDeleteModal"
      title="Supprimer le document"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="400px"
      v-on:ok="confirmDeleteDocument"
      v-on:cancel="showDeleteModal = false"
    >
      <div class="modal-content">
        <h3>Supprimer le document</h3>
        <p>Êtes-vous sûr de vouloir supprimer ce document ?</p>
      </div>
    </va-modal>

  </div>

</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "documents-formation-entreprise",
  props: ["value", "identreprise"],
  data() {
    return {
      pdfurl: '',
      showDocuments: this.value,
      identrepriseDocument: this.identreprise,
      documentsList: [],
      entrepriseNom: '',
      showDeleteModal: false,
      documentToDelete: null,
      showUploadModal: false,
      uploadFormData: {
        date_document: '',
        file: []
      }
    };
  },
  methods: {

    closeUploadModal() {
      this.showUploadModal = false;
    },
    uploadDocument() {
      if (
        !this.uploadFormData.date_document ||
        !this.uploadFormData.file ||
        this.uploadFormData.file.length !== 1
      ) {
        this.launchEpicmaxToast('Veuillez remplir tous les champs du formulaire et sélectionner un fichier PDF.');
        return;
      }
      const formData = new FormData();
      formData.append('identreprise', this.identrepriseDocument);
      console.log(this.uploadFormData.date_document);
      formData.append('date_document', this.uploadFormData.date_document);
      formData.append('document', this.uploadFormData.file[0]);
      axios.post('/api/afpf/upload-document-rne', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(() => {

        this.launchEpicmaxToast('Document téléversé avec succès.');
        this.getDocuments();
        this.uploadFormData.date_document = '';
        this.uploadFormData.file = [];

      }).catch(() => {
        this.launchEpicmaxToast('Erreur lors du téléversement du document.');
      });
    },
    async downloadDocument(idformation_rne) {
      try {
        let pdf = await this.getBulletin(idformation_rne);
        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdf);
        link.download = `document_rne_${this.entrepriseNom}.pdf`;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (err) {
        // TODO deal with error
        console.log(err);
        this.launchEpicmaxToast("Erreur lors du téléchargement");
      }
    },
    async viewDocument(idformation_rne) {
      try {
        let pdf = await this.getBulletin(idformation_rne);
        this.pdfurl = URL.createObjectURL(pdf);

      } catch (err) {
        // TODO deal with error
        console.log(err);
        this.launchEpicmaxToast("Erreur lors du téléchargement");
      }
    },
    async getBulletin(idformation_rne) {
      try {
        let resp = await axios.get("/api/afpf/download-document-rne", {
          params: { idformation_rne: idformation_rne },
          responseType: "blob"
        });
        const blob = new Blob([resp.data], {
          type: "application/pdf"
        });
        return blob;
      } catch (err) {
        //TODO manage error
        this.launchEpicmaxToast("Erreur lors de la recherche de la feuille d'émargement");

        console.log(err);
      }
    },
    deleteDocument(idformation_rne) {
      this.documentToDelete = idformation_rne;
      this.showDeleteModal = true;
    },
    confirmDeleteDocument() {
      if (!this.documentToDelete) return;
      axios.delete('/api/afpf/delete-document-rne', {
        params: { idformation_rne: this.documentToDelete }
      })
        .then(() => {
          this.launchEpicmaxToast('Document supprimé avec succès.');
          this.getDocuments();
        })
        .catch(() => {
          this.launchEpicmaxToast('Erreur lors de la suppression du document.');
        })
        .finally(() => {
          this.showDeleteModal = false;
          this.documentToDelete = null;
          this.getDocuments();
        });
    },
    async getDocuments() {
      try {
        this.identrepriseDocument = this.identreprise;
        let response = await axios.get(
          '/api/afpf/list-documents-entreprise', { params: { identreprise: this.identrepriseDocument } }
        );

        response.data.documents.forEach(doc => {
          doc.date_document_fr = moment(doc.date_document).format('DD/MM/YYYY');
          doc.date_ajout_fr = moment(doc.date_ajout).format('DD/MM/YYYY');
          doc.televersement = doc.utilisateur ? doc.utilisateur.prenom + ' ' + doc.utilisateur.nom : 'Inconnu';
          // validity is up to three months after date_document
          doc.validity = doc.date_document
            ? moment().isBefore(moment(doc.date_document).add(3, 'months'))
            : true;
        });
        this.documentsList = response.data.documents;
        this.entrepriseNom = response.data.entreprise.nom;
        this.pdfurl = '';
      } catch (error) {
        this.launchEpicmaxToast(
          "Impossible de charger les documents."
        );
        console.error("Error fetching documents:", error);
      }
    },
    closeModal() {
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    }
  },
  computed: {
    perPage() {
      return 10;
    },
    fieldsDocuments() {
      return [
        {
          name: "date_document_fr",
          title: "Date du document",
        },

        {
          name: "date_ajout_fr",
          title: "Date d'ajout",
        },
        {
          name: "televersement",
          title: "Téléversé par",
        },
        {
          name: "__slot:validity",
          title: "Validité",
        },
        {
          name: "__slot:actions",
          title: "Actions",
        },
      ];
    },
  },

  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showDocuments = this.value;
      //  this.resetValues();
      if (this.value && this.identreprise) {
        this.getDocuments();
      }
    }
  },
};
</script>

<style scoped>
.customsize {
  width: 80vw;
  height: 60vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.forcewidth {
  width: 100%;
}

.fullsize {
  width: 100%;
  height: 50vh;
}

.setheight {
  height: 60%;
}
</style>

